import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './ComponentsWrapper.css';
import React, { useRef, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
function handleScrollToRef(scrollElemRef, extraHeightCalculator) {
  if (!scrollElemRef.current) {
    return;
  }
  var scrollElem = scrollElemRef.current;
  if (!scrollElem) {
    return;
  }
  var mainHeight = 0;
  var mainNav = document.querySelector('.main-nav-static');
  if (mainNav) {
    mainHeight = mainNav.clientHeight;
  }
  var extraHeight = extraHeightCalculator && mainNav ? extraHeightCalculator(mainNav) : 0;
  var combinedHeight = mainHeight + extraHeight + 10;
  var rect = scrollElem.getBoundingClientRect();
  var scrollPosition = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
  window.scrollTo(0, scrollPosition - combinedHeight);
}
var ComponentsWrapper = function ComponentsWrapper(_ref) {
  var _ref$removePaddingMob = _ref.removePaddingMobile,
    removePaddingMobile = _ref$removePaddingMob === void 0 ? false : _ref$removePaddingMob,
    _ref$removePaddingHea = _ref.removePaddingHeader,
    removePaddingHeader = _ref$removePaddingHea === void 0 ? false : _ref$removePaddingHea,
    _ref$removePaddingBot = _ref.removePaddingBottom,
    removePaddingBottom = _ref$removePaddingBot === void 0 ? false : _ref$removePaddingBot,
    _ref$removePaddingTop = _ref.removePaddingTop,
    removePaddingTop = _ref$removePaddingTop === void 0 ? false : _ref$removePaddingTop,
    _ref$removePadding = _ref.removePadding,
    removePadding = _ref$removePadding === void 0 ? false : _ref$removePadding,
    _ref$removePaddingIns = _ref.removePaddingInside,
    removePaddingInside = _ref$removePaddingIns === void 0 ? false : _ref$removePaddingIns,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? false : _ref$minHeight,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    children = _ref.children,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    anchorUrlParameter = _ref.anchorUrlParameter,
    _ref$componentTabInde = _ref.componentTabIndex,
    componentTabIndex = _ref$componentTabInde === void 0 ? 0 : _ref$componentTabInde;
  var siteName = '';
  var componentRef = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    offsetTop = _useState2[0],
    setOffsetTop = _useState2[1];
  var history = useHistory();
  var hash = history.location.hash && decodeURI(history.location.hash.split('#')[1]) || null;
  var extraHeightCalculator = function extraHeightCalculator(mainNavElem) {
    var afterHeight = parseInt(window.getComputedStyle(mainNavElem, '::after').height || '');
    return afterHeight;
  };
  var handleScroll = function handleScroll() {
    // @ts-ignore
    if (componentRef && componentRef.current && componentRef.current.offsetTop != offsetTop)
      // @ts-ignore
      setOffsetTop(componentRef.current.offsetTop || 0);
  };
  useEffect(function () {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      handleScrollToRef(componentRef, extraHeightCalculator);
    }
  }, [offsetTop]);
  useEffect(function () {
    if (anchorUrlParameter && componentRef && hash && anchorUrlParameter == hash) {
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);
  var conditionalWrapperProps = useMemo(function () {
    if (componentTabIndex === 'disabled') {
      return {};
    }
    return {
      tabIndex: componentTabIndex
    };
  }, [componentTabIndex]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "container ".concat(siteName, " ").concat(className, " ").concat(minHeight ? commonStyles : ''),
    "data-anhor": anchorUrlParameter,
    ref: componentRef,
    style: style
  }, conditionalWrapperProps), /*#__PURE__*/React.createElement("div", {
    className: clsx({
      'module-group': !fullWidth,
      'remove-padding-mobile': removePaddingMobile,
      'remove-padding-header': removePaddingHeader,
      'remove-padding': removePadding,
      'remove-padding-bottom': removePaddingBottom,
      'remove-padding-top': removePaddingTop,
      'remove-padding-inside': removePaddingInside
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, typeof children === 'function' ? children() : /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, children)))));
};
var commonStyles = "c1nbdvx8";
export default ComponentsWrapper;